const PUBLIC_BADGE_BASE_PATH = `${process.env.PUBLIC_URL || ""}/achievement-badges`;
const FALLBACK_BADGE_ICON_PATH = `${PUBLIC_BADGE_BASE_PATH}/fallback.svg`;

const ACHIEVEMENT_ICON_REGISTRY: Record<string, string> = {
  trade_1: `${PUBLIC_BADGE_BASE_PATH}/trade_1.svg`,
  trade_10: `${PUBLIC_BADGE_BASE_PATH}/trade_10.svg`,
  trade_25: `${PUBLIC_BADGE_BASE_PATH}/trade_25.svg`,
  trade_50: `${PUBLIC_BADGE_BASE_PATH}/trade_50.svg`,
  trade_100: `${PUBLIC_BADGE_BASE_PATH}/trade_100.svg`,
  trade_250: `${PUBLIC_BADGE_BASE_PATH}/trade_250.svg`,
  trade_500: `${PUBLIC_BADGE_BASE_PATH}/trade_500.svg`,
  bounty_1: `${PUBLIC_BADGE_BASE_PATH}/bounty_1.svg`,
  bounty_5: `${PUBLIC_BADGE_BASE_PATH}/bounty_5.svg`,
  bounty_15: `${PUBLIC_BADGE_BASE_PATH}/bounty_15.svg`,
  bounty_25: `${PUBLIC_BADGE_BASE_PATH}/bounty_25.svg`,
  bounty_50: `${PUBLIC_BADGE_BASE_PATH}/bounty_50.svg`,
  bounty_100: `${PUBLIC_BADGE_BASE_PATH}/bounty_100.svg`,
  trust_trusted_trader: `${PUBLIC_BADGE_BASE_PATH}/trust_trusted_trader.svg`,
  trust_verified_trader: `${PUBLIC_BADGE_BASE_PATH}/trust_verified_trader.svg`,
  trust_clean_record: `${PUBLIC_BADGE_BASE_PATH}/trust_clean_record.svg`,
  trust_reputation_elite: `${PUBLIC_BADGE_BASE_PATH}/trust_reputation_elite.svg`,
  trust_community_pillar: `${PUBLIC_BADGE_BASE_PATH}/trust_community_pillar.svg`,
  trust_engine_certified: `${PUBLIC_BADGE_BASE_PATH}/trust_engine_certified.svg`,
  fallback: FALLBACK_BADGE_ICON_PATH,
};

export function getAchievementBadgeIconKey(key: string): string {
  return ACHIEVEMENT_ICON_REGISTRY[key] ? key : "fallback";
}

export function getAchievementBadgeIconPath(key: string): string {
  const iconPath = ACHIEVEMENT_ICON_REGISTRY[getAchievementBadgeIconKey(String(key || ""))];
  return iconPath || FALLBACK_BADGE_ICON_PATH;
}
